import { ScheduleActivityHistoryType } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/schedule_activity.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { useLocationTimezone, useScheduleActivityAccess } from '@frontend/schedule-helpers';
import { useContactPanelShallowStore } from '@frontend/shared';
import { Avatar, Text } from '@frontend/design-system';
import { formatDateByRecency } from '../../utils/date-helpers';
import { Card } from './Card';

type Props = {
  locationId: string;
  bookingSubmissionId: string;
};

export const ActivityHistoryCard = ({ locationId, bookingSubmissionId }: Props) => {
  const { t } = useTranslation('scheduleCalendarRequest');
  const { locationTimezone } = useLocationTimezone(locationId);
  const { isScheduleActivityEnabled } = useScheduleActivityAccess();
  const { setPersonId, setSelectedTab } = useContactPanelShallowStore('setPersonId', 'setSelectedTab');

  const { data } = SchedulerV3.Queries.useListScheduleActivityHistoryQuery({
    request: {
      locationId,
      bookingSubmissionId,
      historyType: ScheduleActivityHistoryType.SCHEDULE_ACTIVITY_HISTORY_TYPE_BOOKING_REQUEST,
    },
    options: {
      enabled: !!(isScheduleActivityEnabled && locationId && bookingSubmissionId),
    },
  });

  // NOTE: For now, there can only be one history item for a booking submission, i.e. the booking submission event
  const historyItem = data?.history?.[0];

  const handleAvatarClick = () => {
    if (!historyItem?.actor?.actorUserId) return;
    setPersonId(historyItem.actor.actorUserId, true);
    setSelectedTab('overview-tab');
  };

  if (!data?.history?.length) {
    return null;
  }

  return (
    <Card title={t('History')}>
      <div css={{ display: 'flex', flexDirection: 'column', gap: 'var(--fabric-space-gap-xxs)' }}>
        <Text weight='bold' css={{ marginBottom: 16 }}>
          {t('Requested via Online Scheduling')}
        </Text>
        <div css={{ display: 'flex', alignItems: 'center', gap: 'var(--fabric-space-gap-xs)' }}>
          <Avatar size='small' name={historyItem?.actor?.actorUserName || ''} onClick={handleAvatarClick} />
          <div css={{ display: 'flex', flexDirection: 'column' }}>
            <Text size='medium'>{t('Self Added')}</Text>
            <Text size='small'>{formatDateByRecency(historyItem?.occurredAt, locationTimezone)}</Text>
          </div>
        </div>
      </div>
    </Card>
  );
};
